import { memo } from 'react';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';

function AggregatorNameForm({ aggregatorName, changeValue }) {
  return (
    <>
      <Col md={2} className="bo-same-line">
        <Form.Label>Name:</Form.Label>
      </Col>
      <Col md={4} className="bo-same-line">
        <Form.Control
          className="bo-input"
          type="text"
          name="name"
          id="name"
          placeholder="Aggregator name"
          value={aggregatorName || ''}
          onChange={changeValue}
        />
      </Col>
    </>
  );
}

export default memo(AggregatorNameForm);
